// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1yFjo","notes":"Notes_notes__3HfWT","note":"Notes_note__Ixw0D","markdown":"Notes_markdown__EY69e"};